import { RESET_DATATABLES_FILTER } from '../constants';

export const actionResetDataTablesFilter = () => {
  return async dispatch => {
    dispatch({ type: RESET_DATATABLES_FILTER });
  };
};

export default actionResetDataTablesFilter;
